import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const skuLargeImagesFragment = `
    on ${QueryType.skus} {
        media {
            large {
                src
                alt
            }
        }
    }
`;

export const skuLargeImagesFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.skus]: skuLargeImagesFragment
    };
};
